import React from "react";
import {
    Container,
    Typography,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const Bordrolama = () => {
    return (
        <Container maxWidth="md" sx={{py: 5}}>
            <Box textAlign="center" mb={4}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Muhasebe Hizmetlerimizle Finansal İstikrar Sağlayın.
                </Typography>
            </Box>

            <Typography variant="body2" color="textPrimary" paragraph>
                İşletmenizin çalışanlarının çalışma günlerini, fazla mesailerini, prim ve ikramiye gibi ek ödemelerini veya kesintilerini hesaplamakta yardıma mı ihtiyacınız var? Tüm bu süreçleri uzmanlara bırakarak, mali tablolarınızın, bordro ve SGK işlemlerinizin güvenilir ellerde olduğundan emin olun!
            </Typography>

            <Typography variant="body2" color="textPrimary" paragraph>
                Dijital ortamlara entegre sistemimiz sayesinde, çalışanlarınızın özlük bilgilerini ve bordro kayıtlarını tutuyoruz. Aynı zamanda personel ücretlendirmeleri ve ücret maliyetlendirmesi konusunda da size destek sağlıyoruz. Bu sayede bütçe planlamanızı daha verimli ve sağlıklı bir şekilde yapmanızı sağlıyoruz.
            </Typography>

            <Typography variant="h8" fontWeight="bold" gutterBottom>
                Başlıca Bordrolama Hizmetlerimiz Şunlardır;
            </Typography>
            <List>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="İşe giriş ve çıkış bildirgelerinin hazırlanması" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="Özlük dosyasının hazırlanması ve saklanması" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="İş sözleşmelerinin hazırlanması ve saklanması"
                                  primaryTypographyProps={{
                                      fontWeight: 'medium',
                                      variant: 'body2',
                                  }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="5746 ve 4691 sayılı kanun kapsamında ücret bordrolarının hazırlanması"
                                  primaryTypographyProps={{
                                      fontWeight: 'medium',
                                      variant: 'body2',
                                  }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="5510, 6111 ve 7103 sayılı kanun kapsamında ücret bordrolarının hazırlanması" primaryTypographyProps={{
                        fontWeight: 'medium',
                        variant: 'body2',
                    }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText primary="SGK aylık bildirgelerinin yapılması"
                                  primaryTypographyProps={{
                                      fontWeight: 'medium',
                                      variant: 'body2',
                                  }}/>
                </ListItem>
                <ListItem>
                    <ListItemIcon><CheckIcon color="success"/></ListItemIcon>
                    <ListItemText
                        primary="Şirket çalışanlarının SGK Teşviklerinin sorgulanması ve teşviklerin uygulanması"
                        primaryTypographyProps={{
                            fontWeight: 'medium',
                            variant: 'body2',
                        }}/>
                </ListItem>
            </List>

            <Typography variant="body2" color="textPrimary" paragraph>
                Eğer bordrolama süreçlerinizi daha az maliyetli hale getirmek ve finansal yapılandırmanız için profesyonel bir destek almak isterseniz, hemen bizimle iletişime geçin!
            </Typography>

        </Container>
    );
};

export default Bordrolama;
